import parseHtml from 'html-react-parser'

import { useTheme } from '@mui/material/styles'
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material'

const InstanceDataSelector = ({ value, updateValue, sourcePaths, dataSelector, instanceData, scannerInstanceData, limitedEditingOnly }) => {

  const theme = useTheme()

  let items = [<MenuItem key="Choose..." disabled value="Choose..."><em>Choose...</em></MenuItem>]

  sourcePaths.map(s => {
    let resolvedValue = dataSelector({ template: { s }, instanceData, scannerInstanceData, path: "s" })

    items.push(<MenuItem key={s} value={s}>
      <div className="popupEditorMenuItem popupEditorSelectOption">
        <div className="value" style={{ color: theme.palette.primary.main }}>{s.replace(/[{}]/g, "")}</div>
        <div className="resolved text-gray-500">{parseHtml(resolvedValue ? resolvedValue.toString().replace(/</g,'&lt;') : "")}</div>
      </div>
    </MenuItem>)
  })


  // items starts out with just scanner instance data, then gets updated with instance data
  // This can mean that our selected value isn't intially present - which causes a react error
  // So we are making sure it exists or setting it to "Choose..."
  const valueInSourcePaths = sourcePaths.filter(i => i === value).length > 0
  const label = "Sample data item"

  if (sourcePaths.length) return (

    <FormControl fullWidth variant="outlined">
      <InputLabel id="demo-select-label">{label}</InputLabel>
      <Select
        onChange={e => updateValue(e.target.value)}
        renderValue={selected => selected} // Uses the value rather than our styled menuItem content for the selected item
        value={value && valueInSourcePaths ? value : "Choose..."}
        fullWidth
        label={label}
        className='mb-2'
        disabled={limitedEditingOnly}
      >
        {items}
      </Select>
    </FormControl>
  )
}

export default InstanceDataSelector